import $ from "jquery"

# ==================================================
# > CONTACT CLASS
# ==================================================
class Contact

    constructor: (@$overlay) ->
        @$close = @$overlay.find(".close").click => @close()
        @$box   = @$overlay.find(".contact-box").click (e) -> e.stopPropagation()

        @$overlay.click => @close()

    open: ->
        @$overlay.addClass "shown"
        @checkDimentions()

    close: ->
        @$overlay.removeClass "shown"
        history.pushState {}, "", window.location.origin + window.location.pathname

    checkDimentions: ->

        if $(window).innerHeight() < @$box.innerHeight()
            @$box.addClass "scrollable"
        else
            @$box.removeClass "scrollable"



# ==================================================
# > CONTACT CALLECTION
# ==================================================
class Contacts

    constructor: ->
        @contacts = []
        $(window).on "hashchange", => @check()

    add: ($overlay, hash) ->
        @contacts[hash] = new Contact $overlay

    check: ->
        if @contacts[window.location.hash]
            @contacts[window.location.hash].open()




# ==================================================
# > INIT
# ==================================================
$ ->
    c = new Contacts

    c.add $(".overlay.overlay--newsletter"), "#formulaire-newsletter"
    c.add $(".overlay.overlay--offers"), "#formulaire-nouvelles-offres"

    c.check()


// WEBPACK FOOTER //
// ./scripts/modules/contact.coffee